/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ReportSummaryView } from './ReportSummaryView';
export type ReportListItemView = {
    reportId?: string;
    shopId?: string;
    shopHost?: string;
    frequency?: ReportListItemView.frequency;
    periodStart?: string;
    periodEnd?: string;
    /**
     * ISO 8601
     */
    generatedAt?: string;
    /**
     * Currency the summary amounts are in
     */
    currency?: string | null;
    summary: ReportSummaryView;
};
export namespace ReportListItemView {
    export enum frequency {
        DAILY = 'daily',
        WEEKLY = 'weekly',
        MONTHLY = 'monthly',
    }
}

